export default __webpack_public_path__ + "static/media/Linktree-QR.75192edc.png";